<script lang="ts">
    import {generateMockSegmentedData} from './mock-data';
    import KpSegmentedBarChart from 'shared/components/kp-charts/bar-chart/KpSegmentedBarChart.svelte';
    import OptimisationOverviewContainer from './components/OptimisationOverviewContainer.svelte';
    import OptimisationOverviewHeading from './components/OptimisationOverviewHeading.svelte';
    import KpBarebonesTable from 'shared/ui-widgets/table/barebones/KpBarebonesTable.svelte';
    import ColoredLabel from '../../../../../components/ColoredLabel.svelte';
</script>

<OptimisationOverviewContainer>
    <OptimisationOverviewHeading heading="Předávací protokol" printButtonLabel="Tisk předávacího protokolu"/>

    <KpBarebonesTable rowsTopBordered headerFooterDivided fontSize="12px">
        <tr slot="header">
            <th>Profese</th>
            <th>Vykázáno (S + P)</th>
            <th>Účtováno (S + P)</th>
            <th>Vykázané náklady</th>
            <th>Účtované náklady</th>
        </tr>

        <svelte:fragment slot="body">
            <tr>
                <td>
                    <ColoredLabel label="Technik strojní"/>
                </td>
                <td>100h + 20h</td>
                <td>120h + 30h</td>
                <td>80 600 Kč</td>
                <td>110 000 Kč</td>
            </tr>
        </svelte:fragment>

        <svelte:fragment slot="footer">
            <tr class="footer-row">
                <td></td>
                <td>120 hod.</td>
                <td>150 hod.</td>
                <td>80 600 Kč</td>
                <td>110 000 Kč</td>
            </tr>
        </svelte:fragment>
    </KpBarebonesTable>

    <KpSegmentedBarChart height="275px" data="{generateMockSegmentedData()}"/>
</OptimisationOverviewContainer>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .footer-row {
        font-weight: 500;
        font-size: @font-size-large;
    }
</style>